import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import api from "~/api"
import apiv2 from "~/api2"
import { useCamp } from "~/api2/hooks/useCamp"

import { queryKeys } from "~/constants/queryKeys"
import { useNotification } from "~/contexts/NotificationProvider"
import { ReservationProps } from "~/interfaces"

type Props = {
  reservationId?: string
}

export const useReservation = (props: Props) => {
  const { showNotification } = useNotification()
  const {
    index: { data: camp },
  } = useCamp()
  const fetchReservation = useQuery({
    queryKey: [queryKeys.RESERVATION, props.reservationId],
    queryFn: () => findReservation(props.reservationId),
    staleTime: 3000,
    enabled: !!props.reservationId,
  })

  const updateReservation = useMutation<ReservationProps, Error, UpdateReservationProps>({
    mutationFn: updateReservationAction,

    onError: () => {
      showNotification({
        type: "error",
        title: "Changes not successfully saved!",
      })
    },
  })

  return {
    index: fetchReservation,
    update: updateReservation,
  }
}

const findReservation = async (reservationId?: string) => {
  try {
    if (!reservationId) return
    return await apiv2.Reservations.find(reservationId)
  } catch (error) {
    console.error("Error fetching reservation:", error)
    throw error
  }
}

export type UpdateReservationProps = {
  reservationId: string
  props: ReservationProps
}

const updateReservationAction = async ({ reservationId, props }: UpdateReservationProps) => {
  try {
    return await api.updateReservation(reservationId, props)
  } catch (error) {
    console.error("Error updating reservation:", error)
    throw error
  }
}
